<template>
	<div class="record_box animate__animated animate__fadeIn">
		<div class="record">
			<div class="search_box">
				<div class="box_line">
					<div class="line_input">
						<div class="input_title">人员姓名</div>
						<input type="text" class="input_box" placeholder="请输入人员姓名" v-model="searchName" />
					</div>
					<div class="line_input">
						<div class="input_title">打卡类型</div>
						<el-select size="small" v-model="searchType" filterable placeholder="请选择" style="border-radius: 0;">
							<el-option label="请选择" value=""></el-option>
							<el-option label="进门" value="1">进门</el-option>
							<el-option label="出门" value="2">出门</el-option>
							<el-option label="重复进门" value="3">重复进门</el-option>
							<el-option label="重复出门" value="4">重复出门</el-option>
							<el-option label="无效" value="0">无效</el-option>
						</el-select>
					</div>
					<div class="line_input">
						<div class="input_title">所属班组</div>
						<el-select size="small" v-model="searchTeam" filterable placeholder="请选择" style="border-radius: 0;">
							<el-option label="请选择" value=""></el-option>
							<el-option :label="item.name" :key="item.id" :value="item.text" v-for="item in teamList"></el-option>
						</el-select>
					</div>
                    <div class="line_input">
                        <div class="input_title">所属工种</div>
                        <input type="text" class="input_box" placeholder="请输入所属工种" v-model="searchWork" />
                    </div>

					<div class="line_input">
						<div class="input_title">上传状态</div>
						<el-select size="small" v-model="searchUpload" filterable placeholder="请选择" style="border-radius: 0;">
							<el-option label="请选择" value=""></el-option>
							<el-option label="已上传" value="2">已上传</el-option>
							<el-option label="未上传" value="1">未上传</el-option>
						</el-select>
					</div>
				</div>
				<div class="box_line">
					<div class="line_input">
						<div class="input_title">打卡时间</div>
						<el-date-picker
							size="small"
							v-model="searchSignDate"
							type="datetimerange"
							value-format="yyyy-MM-dd HH:mm:ss"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							style="width: 392px;"
						></el-date-picker>
					</div>
					<div class="search-btn" @click="fnSearch"><span>搜索</span></div>
					<div class="search-btn" @click="fnInit"><span>刷新</span></div>
					<div class="search-btn" @click="fnExportExcel"><span>导出Excel</span></div>
					<div class="search-btn" @click="fnExportExcel('cqmohrss2')" v-if="APP.fnCheckRegion('50')"><span>人社导出</span></div>
				</div>
			</div>
			<div class="cont_list">
				<div class="list_title">
					<div class="title_item">姓名</div>
					<div class="title_item">性别</div>
					<div class="title_item">识别卡卡号</div>
					<div class="title_item">部门</div>
					<div class="title_item">职位</div>
					<div class="title_item">是否上传</div>
					<div class="title_item">打卡类型</div>
					<div class="title_item">打卡设备</div>
					<div class="title_item">打卡时间</div>
					<div class="title_item">操作</div>
				</div>
				<div class="list_boxes">
					<div class="list_box">
						<div v-if="tableData">
							<div class="box_line" v-for="(item, index) in tableData" :key="index">
								<div class="list_item">{{ item.name }}</div>
								<div class="list_item">{{ item.sex == '1' ? '男' : '女' }}</div>
								<div class="list_item">{{ item.card_no }}</div>
								<div class="list_item" :title="fnDepartmentFormat(item.department)"><span>{{ fnDepartmentFormat(item.department) }}</span></div>
								<div class="list_item" :title="fnDepartmentFormat(item.position)"><span>{{ fnDepartmentFormat(item.position) }}</span></div>
								<div class="list_item" :title="item.is_upload | fnUploadObjToText"><span>{{ item.is_upload | fnUploadObjToText }}</span></div>
								<!-- <div class="list_item" :title="item.is_upload!='{}'?fnUploadType(item.is_upload):'未上传'"><span>{{ item.is_upload!='{}'?fnUploadType(item.is_upload):'未上传' }}</span></div> -->
								<div class="list_item">{{ fnSignSatusToText(item.sign_type) }}</div>
								<div class="list_item">{{ accessEqptList[item.eqpt_id] ? accessEqptList[item.eqpt_id] : '' }}</div>
								<div class="list_item">{{ item.sign_date }}</div>
								<div class="list_item">
									<div class="btn_line" v-if="item.real_time_face">
										<div class="search-btn" @click="fnLookFace(item.real_time_face)"><span>查看人脸照</span></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="cont_page">
				<el-pagination
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="pageSizes"
					:page-size="pageSize"
					:current-page="currentPage"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pageTotal"
				/>
			</div>
			<div class="dialog_face" v-if="realTimeFace">
				<el-dialog title="实时人脸照" :custom-class="'animate__animated animate__fadeIn'" :modal="false" :visible.sync="realTimeFace" center>
					<img :src="realFaceUrl"/>
					<div slot="footer" class="dialog-footer">
						<div class="btn_line">
							<div class="search-btn red" @click="realTimeFace = false"><span>关闭</span></div>
						</div>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
import APP from '@/utils/base';
import request from '@/utils/request';
import { getUserInfo } from '@/utils/auth';
import { Loading } from 'element-ui';
export default {
	data() {
		return {
            APP:APP,
			pageSize: APP.PAGE.LIMIT,
			pageSizes: APP.PAGE.SIZE_OPTION,
			currentPage: APP.PAGE.SKIP_PAGE,
			pageTotal: 0,
			userInfo: null, // 用户信息
			searchName: '', // 搜索人员姓名
			searchType: '', // 搜索打卡类型
			searchUpload: '', // 搜索上传状态
			searchSignDate: '', // 搜索打卡时间
			searchTeam: '', // 搜索所属班组
			searchWork: '', // 搜索所属工作
			tableData: [], // 表格列表
			realTimeFace: false, // 实时人脸照弹窗
			realFaceUrl: '', // 人脸url
			teamList: [], // 班组列表
			accessEqptList: [], // 门禁设备列表
			excelData: [], // excel表格数据
			loading: false,
			downloadLoading: false
		};
	},
	created() {
		this.fnInit();
	},
	methods: {
		// 更改分页内容
		handleSizeChange(val) {
			this.pageSize = val;
			this.fnGetData(
				{
					page: this.currentPage,
					size: this.pageSize,
					name: this.searchName,
					sign_date: this.searchSignDate ? this.searchSignDate.join(',') : '',
					sign_type: this.searchType,
					is_upload: this.searchUpload,
					department: this.searchTeam,
					position: this.searchWork
				},
				res => {
					this.tableData = res.data.query;
					this.pageTotal = res.data.count;
				}
			);
		},
		// 翻页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.fnGetData(
				{
					page: this.currentPage,
					size: this.pageSize,
					name: this.searchName,
					sign_date: this.searchSignDate ? this.searchSignDate.join(',') : '',
					sign_type: this.searchType,
					is_upload: this.searchUpload,
					department: this.searchTeam,
					position: this.searchWork
				},
				res => {
					this.tableData = res.data.query;
					this.pageTotal = res.data.count;
				}
			);
		},
		// 初始化
		fnInit() {
			this.userInfo = getUserInfo();
			this.fnGetData(
				{
					page: this.currentPage,
					size: this.pageSize
				},
				res => {
					this.tableData = res.data.query;
					this.pageTotal = res.data.count;
				}
			);
			// 获取门禁设备
			this.fnGetAccessEqpt();
			// 获取班组
			this.fnGetAllTeam();
		},
		// 获取所有班组
		fnGetAllTeam() {
			request({
				url: 'team/getTeam',
				method: 'GET'
			})
				.then(res => {
					let _data = res.data;
					let _arr = [];
					_data.forEach(item => {
						_arr.push({
							name: item.name,
							id: item.id,
							text: item.id + '#' + item.name
						});
					});
					this.teamList = _arr;
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 获取数据
		fnGetData(_param, _cb) {
			request({
				url: 'attendance/get',
				method: 'GET',
				params: _param
			})
				.then(res => {
					_cb && _cb(res);
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 搜索
		fnSearch() {
			this.currentPage = APP.PAGE.SKIP_PAGE;
			this.fnGetData(
				{
					page: this.currentPage,
					size: this.pageSize,
					name: this.searchName,
					sign_date: this.searchSignDate ? this.searchSignDate.join(',') : '',
					sign_type: this.searchType,
					is_upload: this.searchUpload,
					department: this.searchTeam,
					position: this.searchWork
				},
				res => {
					this.tableData = res.data.query;
					this.pageTotal = res.data.count;
				}
			);
		},
		// 获取打卡设备
		fnGetAccessEqpt() {
			request({
				url: '/accessEqpt/get',
				method: 'get'
			})
				.then(res => {
					let _data = res.data.query;

					if (_data.length) {
						for (let _key in _data) {
							this.accessEqptList[_data[_key]['id']] = _data[_key]['name'];
						}
					}
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 打卡状态文字转换
		fnSignSatusToText(_type) {
			switch(_type) {
				case 1:
				case 3:
					return '进';
				case 2:
				case 4:
					return '出';
				case 0:
				default:
					return '';
			}
		},
		// 查看人脸照
		fnLookFace(_url) {
			this.realFaceUrl = _url;
			this.realTimeFace = true;
		},
		// 部门、职位去除#号
		fnDepartmentFormat(_text) {
			return APP.fnTeamFormat(_text);
		},
		// 格式化签到日期为 yyyy/m/d h:mm 格式
		formatSignDate(_dateStr) {
			if (!_dateStr) return '';
			const date = new Date(_dateStr);
			const year = date.getFullYear();
			const month = date.getMonth() + 1;
			const day = date.getDate();
			const hours = date.getHours();
			const minutes = date.getMinutes();
			return `${year}/${month}/${day} ${hours}:${minutes.toString().padStart(2, '0')}`;
		},
		// 导出excel
		fnExportExcel(type) {
			let _that = this;
			_that.excelData = [];
			_that.loadingInstance = Loading.service({
				fullscreen: true,
				background: 'rgba(255,255,255,0.7)',
				spinner: 'el-icon-loading',
				text: '导出excel中，请不要关闭网页'
			});
			let _page = 1; // 初始页数
			let _size = 1000; // 查询条数
			_fn();
			function _fn() {
				_that.fnGetData(
					{
						page: _page,
						size: _size,
						name: _that.searchName,
						sign_date: _that.searchSignDate ? _that.searchSignDate.join(',') : '',
						sign_type: _that.searchType,
						is_upload: _that.searchUpload,
						department: _that.searchTeam,
						position: _that.searchWork
					},
					res => {
						if (res.data.query.length) {
							if (_page === 1) {
								_that.excelData = res.data.query;
							} else {
								_that.excelData = _that.excelData.concat(res.data.query);
							}
							_page++;
							_fn();
						} else {
                            if(type == 'cqmohrss2'){
                                _that.fnSetExcelCqmohrss2Data();
                            }else{
                                _that.fnSetExcelData();
                            }
						}
					}
				);
			}
		},
		// 上传地址
		fnUploadType (_obj) {
		  _obj = typeof _obj === 'object' ? _obj : JSON.parse(_obj)
		  let _arr = []
		  let _site = ''

		  for (let _item in _obj) {
		    switch (_item) {
		      case 'lj':
		        _site = '已上传至两江新区——' + _obj[_item]
		        _arr.push(_site)
		        break
		      case 'cq':
		        _site = '已上传至重庆市建委——' + _obj[_item]
		        _arr.push(_site)
		        break
					case 'cd':
					  _site = '已上传至成都市建委——' + _obj[_item]
					  _arr.push(_site)
					  break
		      default:
		        _site = '已上传——' + _obj[_item]
		        _arr.push(_site)
		    }
		  }
		  return _arr.join('')
		},
        // 组装excel数据
        fnSetExcelCqmohrss2Data() {
        	if (!this.excelData) {
        		this.loadingInstance.close();
        		return;
        	}
        	let _excelData = [];
        	this.excelData.forEach(_item => {
        		let _needData = {
        			name: _item.name,
                    idcard: _item.idcard,
        			project_name: getUserInfo().name,
        			department: this.fnDepartmentFormat(_item.department),
        			sign_type: this.fnSignSatusToText(_item.sign_type),
        			sign_date: this.formatSignDate(_item.sign_date)
        		};
                _excelData.push(_needData)
        	});
        	const { export_json_to_excel } = require('../../../../vendor/Export2Excel.js');
        	const tHeader = ['班组名称', '姓名', '身份证号', '考勤时间（格式：yyyy/m/d h:mm）', '考勤方向（下拉选择）'];
        	const filterVal = ['department', 'name', 'idcard', 'sign_date', 'sign_type'];
        	const data = APP.formatJson(filterVal, _excelData);
        	const _filename = getUserInfo().name + '-' + '考勤记录';
        	export_json_to_excel({
        		header: tHeader,
        		data,
        		filename: _filename
        	});
        	this.loadingInstance.close();
        },
		// 组装excel数据
		fnSetExcelData() {
			if (!this.excelData) {
				this.loadingInstance.close();
				return;
			}
			let _excelData = [];
			let _countData = {};
			this.excelData.forEach(_item => {
				let _needData = {
					id: _item.id,
					name: _item.name,
					sex: _item.sex == 1 ? '男' : '女',
					card_no: _item.card_no,
					project_name: getUserInfo().name,
					department: this.fnDepartmentFormat(_item.department),
					position: this.fnDepartmentFormat(_item.position),
					is_upload: _item.is_upload!='{}'?this.fnUploadType(_item.is_upload):'未上传',
					sign_type: this.fnSignSatusToText(_item.sign_type),
					sign_eqpt: this.accessEqptList[_item.eqpt_id],
					sign_date: _item.sign_date
				};
				if (_countData[_item.personnel_id]) {
					_countData[_item.personnel_id].push(_needData);
				} else {
					_countData[_item.personnel_id] = [_needData];
				}
			});
			for (let _key in _countData) {
				_excelData = _excelData.length ? _excelData.concat(_countData[_key]) : _countData[_key];
			}
			const { export_json_to_excel } = require('../../../../vendor/Export2Excel.js');
			const tHeader = ['Id', '姓名', '性别', '识别卡卡号', '部门', '职位', '是否上传', '打卡类型', '打卡设备', '打卡时间'];
			const filterVal = ['id', 'name', 'sex', 'card_no', 'department', 'position', 'is_upload', 'sign_type', 'sign_eqpt', 'sign_date'];
			const data = APP.formatJson(filterVal, _excelData);
			const _filename = getUserInfo().name + '-' + '考勤记录';
			export_json_to_excel({
				header: tHeader,
				data,
				filename: _filename
			});
			this.loadingInstance.close();
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.record_box {
	width: 1920px;
	height: 790px;
	position: relative;
	overflow: hidden;
	.record {
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.search_box {
	height: 90px;
	width: 1880px;
	margin-top: 24px;
	margin-left: 20px;
	@include flex-box(space-between, center, column);
	.box_line {
		width: 1880px;
		height: 32px;
		@include flex-box(flex-start, center);
		.line_input {
			min-width: 280px;
			height: 30px;
			margin-right: 10px;
			border-top-right-radius: 1px;
			border-bottom-right-radius: 1px;
			background-color: rgba(49, 88, 128, 0.4);
			@include flex-box(flex-start, center);
			.input_title {
				width: 69px;
				height: 30px;
				font-size: 14px;
				color: #9bf9fc;
				border-radius: 2px;
				background-color: rgba(155, 249, 252, 0.1);
				@include flex-box(center, center);
			}
			.input_box {
				width: 211px;
				height: 30px;
				line-height: 30px;
				padding-left: 15px;
				color: rgba(77, 180, 244, 0.7);
				font-size: 12px;
				border-radius: 2px;
				outline: none;
				background: transparent;
				border: none;
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
			.select_box {
				width: 211px;
				height: 30px;
				border-radius: 2px;
			}
		}
		.add_person {
			width: 106px;
			height: 32px;
			margin-right: 5px;
			cursor: pointer;
			background: url(../../../../assets/img/per_list_add.png) no-repeat;
			background-size: 100% 100%;
		}
		.to_face {
			width: 159px;
			height: 32px;
			margin-right: 5px;
			cursor: pointer;
			background: url(../../../../assets/img/per_btn_toaccess.png) no-repeat;
			background-size: 100% 100%;
		}
		.to_custom {
			width: 159px;
			height: 32px;
			margin-right: 5px;
			cursor: pointer;
			background: url(../../../../assets/img/per_btn_tocustom.png) no-repeat;
			background-size: 100% 100%;
		}
		.to_export {
			width: 106px;
			height: 32px;
			margin-right: 5px;
			cursor: pointer;
			background: url(../../../../assets/img/per_btn_export.png) no-repeat;
			background-size: 100% 100%;
		}
		.to_weixin {
			width: 216px;
			height: 32px;
			cursor: pointer;
			background: url(../../../../assets/img/per_btn_toweixin.png) no-repeat;
			background-size: 100% 100%;
		}
	}
}
.box_line {
	>>> .el-input__inner {
		width: 211px;
		height: 30px;
		border-radius: 2px;
		border: none;
		color: rgba(77, 180, 244, 0.7);
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>> .el-select {
		.el-input {
			.el-select__caret {
				color: rgba(77, 180, 244, 0.7);
			}
		}
	}
	>>> .el-select-dropdown {
		background-color: rgba(77, 180, 244, 0.2);
		border: 1px solid rgba(77, 180, 244, 1);
	}
	>>> .popper__arrow {
		border-bottom-color: rgba(77, 180, 244, 1) !important;
	}
	>>> .el-select-dropdown__item {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-select-dropdown__item:hover {
		color: #409eff;
	}
	>>> .el-select-dropdown__item.hover {
		color: #409eff;
	}
	>>> .el-input__icon {
		color: rgba(77, 180, 244, 0.7);
	}
	>>> .el-range-input {
		background: transparent;
		&::-webkit-input-placeholder {
			color: rgba(77, 180, 244, 0.7);
		}
		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: rgba(77, 180, 244, 0.7);
		}
		&:-ms-input-placeholder {
			/* Internet Explorer 10-11 */
			color: rgba(77, 180, 244, 0.7);
		}
	}
	>>> .el-range-separator {
		color: rgba(77, 180, 244, 0.7);
	}
}
.cont_list {
	margin-top: 29px;
	margin-left: 28px;
	width: 1864px;
	height: 520px;
	border-radius: 10px;
	background-color: rgba(29, 68, 149, 0.1);
	.list_title {
		width: 1864px;
		height: 48px;
		background: url(../../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start, center);
		.title_item {
			height: 48px;
			@include flex-box(center, center);
			&:nth-child(1) {
				width: 166px;
				margin: 0 4px 0 40px;
			}
			&:nth-child(2) {
				width: 166px;
				margin-right: 4px;
			}
			&:nth-child(3) {
				width: 176px;
				margin-right: 4px;
			}
			&:nth-child(4) {
				width: 176px;
				margin-right: 4px;
			}
			&:nth-child(5) {
				width: 176px;
				margin-right: 4px;
			}
			&:nth-child(6) {
				width: 176px;
				margin-right: 4px;
			}
			&:nth-child(7) {
				width: 176px;
				margin-right: 4px;
			}
			&:nth-child(8) {
				width: 176px;
				margin-right: 4px;
			}
			&:nth-child(9) {
				width: 176px;
				margin-right: 4px;
			}
			&:nth-child(10) {
				width: 184px;
				margin-right: 40px;
			}
		}
	}
	.list_boxes {
		width: 1864px;
		height: 472px;
		position: relative;
		overflow: hidden;
		.list_box {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.box_line {
				width: 1784px;
				height: 70px;
				margin: 7px 0 0 40px;
				font-size: 16px;
				color: #ffffff;
				border-bottom: 1px dashed #1d4495;
				@include flex-box(flex-start, center);
				&:hover{
					background-color: rgba(49, 88, 128, 0.4);
				}
				.list_item {
					height: 70px;
					text-align: center;
					@include flex-box(center, center);
					&:nth-child(1) {
						width: 166px;
						margin-right: 4px;
					}
					&:nth-child(2) {
						width: 166px;
						margin-right: 4px;
					}
					&:nth-child(3) {
						width: 176px;
						margin-right: 4px;
					}
					&:nth-child(4) {
						width: 176px;
						margin-right: 4px;
					}
					&:nth-child(5) {
						width: 176px;
						margin-right: 4px;
					}
					&:nth-child(6) {
						width: 176px;
						margin-right: 4px;
					}
					&:nth-child(7) {
						width: 176px;
						margin-right: 4px;
					}
					&:nth-child(8) {
						width: 176px;
						margin-right: 4px;
					}
					&:nth-child(9) {
						width: 176px;
						margin-right: 4px;
					}
					&:nth-child(10) {
						width: 184px;
					}
					span {
						text-align: center;
					  width: 100%;
					  cursor: pointer;
					  overflow: hidden;
					  text-overflow: ellipsis;
					  white-space: nowrap;
					}
				}
			}
		}
	}
}
.dialog_face{
	>>>.el-dialog{
		width: 420px;
		height: 480px;
		margin-top: 23vh!important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58,116,221,1);
	}
	>>>.el-form-item__label{
		color: #4DB4F4;
	}
	>>>.el-dialog__title{
		color: #4DB4F4;
	}
	>>>.el-dialog__close{
		color: #4DB4F4;
	}
	>>>.el-dialog__body{
		@include flex-box(center,center);
	}
	img{
		width: 300px;
	}
}
.btn_line{
	@include flex-box(center,center);
}
</style>



// WEBPACK FOOTER //
// src/views/Attendance/attendanceDefault/components/attendanceRecord.vue